import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const editPartner = async (partner_id: string, name: string, hook: string): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const hooks = {
      created: hook
    };

    const uri = `${config.uri.base_url}/three-pl/${partner_id}/edit`;
    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({ name, hooks })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
